const attachmentTypes = {
  export: [
    {id: 'awb_airwaybill', label: 'Airwaybill'},
    {id: 'awb_iac_certificate', label: 'IAC Certificate'},
    {id: 'dims_sheet', label: 'Dims Sheet'},
    {id: 'awb_ccsf_declaration', label: 'CCSF Declaration'},
    {id: 'awb_consol_manifest', label: 'Consol Manifest'},
    {id: 'awb_commercial_invoice', label: 'Commercial Invoice'},
    {id: 'awb_certificates_required', label: 'Certificates required'},
    {id: 'awb_dg_declaration', label: 'DG Declaration'},
    {id: 'awb_other', label: 'Other'},
    {id: 'driver_id', label: `Driver's Id`},
    {id: 'consignment', label: `Consignment Security Declaration`}
  ], import: [
    {id: 'awb_airwaybill', label: 'Airwaybill'},
    {id: 'awb_consol_manifest', label: 'Consol Manifest'},
    {id: 'awb_commercial_invoice', label: 'Commercial Invoice'},
    {id: 'awb_certificates_required', label: 'Certificates required'},
    {id: 'awb_power_of_attorney', label: 'Power of attorney'},
    {id: 'awb_permit_to_transfer', label: 'Permit to transfer'},
    {id: 'awb_customs_clearance', label: 'Customs clearance'},
    {id: 'awb_other', label: 'Other'},
    {id: 'driver_id', label: `Driver's Id`},
    {id: 'payment_receipt', label: 'Payment Receipt'}
  ]
};

const imgExtensions = ['jpg', 'png', 'jpeg'];
const docExtensions = ['pdf'];

export default {
  attachmentTypes,
  imgExtensions,
  docExtensions
}
